import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getApp } from 'firebase/app';
import './SharedNoteViewer.css'; // We'll create this CSS file next

export default function SharedNoteViewer() {
    const { shareId } = useParams();
    const [note, setNote] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        async function fetchNote() {
            try {
                const functions = getFunctions(getApp());
                const getSharedNote = httpsCallable(functions, 'getSharedNote');
                const result = await getSharedNote({ shareId });
                setNote(result.data);
            } catch (err) {
                console.error(err);
                let msg = 'Failed to load note';
                if (err.code === 'not-found') msg = 'Note not found or link expired';
                if (err.code === 'permission-denied') msg = 'You do not have permission to view this note';
                setError(msg);
            } finally {
                setLoading(false);
            }
        }

        if (shareId) fetchNote();
    }, [shareId]);

    if (loading) {
        return (
            <div className="shared-note-wrapper">
                <div className="loading-state">
                    <div className="spinner"></div>
                    <p>Loading shared note...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="shared-note-wrapper">
                <div className="error-state">
                    <div className="error-icon">😕</div>
                    <h3>Unable to view note</h3>
                    <p>{error}</p>
                </div>
            </div>
        );
    }

    if (!note) return null;

    const date = note.createdAt ? formatDate(note.createdAt) : '';

    function formatDate(timestamp) {
        if (!timestamp) return '';
        let d;
        // Handle Firestore Timestamp (has toDate)
        if (timestamp.toDate && typeof timestamp.toDate === 'function') {
            d = timestamp.toDate();
        }
        // Handle serialized timestamp { _seconds, _nanoseconds } or { seconds, nanoseconds }
        else if (timestamp._seconds || timestamp.seconds) {
            d = new Date((timestamp._seconds || timestamp.seconds) * 1000);
        }
        // Handle string/number/Date
        else {
            d = new Date(timestamp);
        }

        return !isNaN(d.getTime()) ? d.toLocaleDateString() : 'Unknown Date';
    }

    return (
        <div className="shared-note-wrapper">
            <div className="shared-note-container">
                <header className="shared-note-header">
                    <h1 className="shared-note-title">{note.title || 'Untitled Note'}</h1>
                    <div className="shared-note-meta">
                        <div className="meta-item author">
                            <span className="avatar-placeholder">
                                {note.ownerDisplayName ? note.ownerDisplayName[0].toUpperCase() : 'U'}
                            </span>
                            <span>{note.ownerDisplayName || 'Anonymous'}</span>
                        </div>
                        <div className="meta-item date">{date}</div>
                        {note.domain && <div className="meta-item domain">from {note.domain}</div>}
                    </div>
                </header>

                <div
                    className="shared-note-content"
                    dangerouslySetInnerHTML={{ __html: note.content }}
                />

                <footer className="shared-note-footer">
                    <p>Powered by <strong>Page Notes</strong></p>
                    <a href="https://pagenotes.live" target="_blank" rel="noopener noreferrer" className="cta-button">
                        Get the Extension
                    </a>
                </footer>
            </div>
        </div>
    );
}
